import { useEffect, useRef, useState } from "react";
import { Bot, User } from "lucide-react";
import { http, errMsg } from "../../api";

export default function OnboardingChat({ onCompleted, onGoToSteps }) {
  const [data, setData] = useState(null);
  const [typing, setTyping] = useState(false);
  const [error, setError] = useState("");
  const endRef = useRef(null);

  useEffect(() => { http.get("/creator/onboarding").then(r => setData(r.data)).catch(e => setError(errMsg(e))); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" }); }, [data, typing]);

  const reply = async choice => {
    if (choice === "journey") { onGoToSteps(); return; }
    const label = data.options.find(o => o.id === choice)?.label;
    setError(""); setTyping(true);
    setData(d => ({ ...d, options: [], messages: choice === "menu" ? [] : [...d.messages, { from: "user", text: label, at: new Date().toISOString() }] }));
    try {
      const [{ data: res }] = await Promise.all([http.post("/creator/onboarding/reply", { choice }), new Promise(r => setTimeout(r, 800))]);
      setData(res);
      if (res.completed) onCompleted?.();
    } catch (e) { setError(errMsg(e)); http.get("/creator/onboarding").then(r => setData(r.data)); }
    finally { setTyping(false); }
  };

  if (error && !data) return <div className="notice error" data-testid="onboarding-error">{error}</div>;
  if (!data) return <div className="loading">Connecting you to the hiring assistant…</div>;
  return (
    <section className="chat-shell" data-testid="onboarding-chat">
      <header className="chat-head">
        <span className="chat-avatar"><Bot size={18} /></span>
        <div><strong data-testid="chat-agent-name">{data.agent_name}</strong><small>Automated assistant · answers in seconds</small></div>
        {data.completed && <span className="badge success" data-testid="chat-completed-badge">Onboarding complete</span>}
      </header>
      <div className="chat-body" data-testid="chat-messages">
        {data.messages.map((m, i) => (
          <div key={i} className={`chat-row ${m.from}`} data-testid={`chat-message-${m.from}-${i}`}>
            <span className="chat-bubble-avatar">{m.from === "agent" ? <Bot size={14} /> : <User size={14} />}</span>
            <div className="chat-bubble">{m.text.split("\n").map((line, j) => <p key={j}>{line || "\u00a0"}</p>)}</div>
          </div>
        ))}
        {typing && <div className="chat-row agent" data-testid="chat-typing"><span className="chat-bubble-avatar"><Bot size={14} /></span><div className="chat-bubble typing"><i /><i /><i /></div></div>}
        <div ref={endRef} />
      </div>
      <footer className="chat-options" data-testid="chat-options">
        {error && <div className="notice error" style={{ width: "100%" }}>{error}</div>}
        {!typing && data.options.map(o => (
          <button key={o.id} className={`chat-option ${o.id === "yes" || o.id === "journey" ? "primary-opt" : ""}`} onClick={() => reply(o.id)} data-testid={`chat-option-${o.id}`}>{o.label}</button>
        ))}
      </footer>
    </section>
  );
}
